export default __webpack_public_path__ + "static/soehne-web-halbfett-kursiv-3ff84be1db714f469dd1af13ef51f24f.eot";